<template>
  <div>
    <div class="container form-signin3">
      <div class="row">
        <div class="col-md-12" style="padding-left: 50px; padding-right: 50px">
          <!-- <h2
            class="text-start"
            style="color: rgb(29, 68, 91); font-weight: 600"
          >
            Default
          </h2> -->
          <form class="form-inline transparent-form border-page" style="padding: 5px !important;">
            <div class="col-lg-12 col-md-12 row">
              <div class="col-lg-2 col-sm-2">
                <label
                  class="col-form-label"
                  style="display: flex; justify-content: flex-start"
                >
                  Client
                  <span class="text-danger">*</span>
                </label>
                <Multiselect
                  mode="single"
                  trackBy="new_name"
                  label="new_name"
                  valueProp="id"
                  class="register-select"
                  placeholder=" Client"
                  v-model="detail.user_id"
                  :options="client_list"
                  @select="getList()"
                  searchable="true"
                />
              </div>
              <div class="col-lg-2 col-sm-2" v-if="detail.range == 1">
                <label
                  class="col-form-label"
                  style="display: flex; justify-content: flex-start"
                >
                  Symbol
                  <span class="text-danger">*</span>
                </label>
                <Multiselect
                  mode="single"
                  trackBy="name"
                  disabled
                  label="name"
                  valueProp="instrument_token"
                  class="register-select"
                  placeholder="Script"
                  searchable="true"
                />
              </div>
              <div class="col-lg-2 col-sm-2" v-if="detail.range == 0">
                <label
                  class="col-form-label"
                  style="display: flex; justify-content: flex-start"
                >
                  Symbol
                  <span class="text-danger">*</span>
                </label>
                <Multiselect
                  mode="single"
                  trackBy="name"
                  label="name"
                  valueProp="name"
                  class="register-select"
                  placeholder=" Script"
                  v-model="detail.instrument_token"
                  :options="script_list"
                  searchable="true"
                />
              </div>
              <div class="col-lg-3 col-md-4 col-sm-4 row " style="margin: 0;padding: 0;">
                <div
                  class="col-lg-6 col-md-5 col-sm-5"
                  style="margin-top: -6px"
                >
                  <div
                    class="mt-2 row ml-2"
                    style="font-size: 12px; font-weight: 550 !important"
                  >
                    <input
                      id="is_broker_gross"
                      name="is_broker_gross"
                      type="checkbox"
                      v-on:change="emptyValue()"
                      v-model="detail.range"
                      class="ml-1"
                      :true-value="1"
                      :false-value="0"
                    />
                    <label class="col-form-label" style="display: flex"
                      ><span class="ml-2">Range </span></label
                    >
                  </div>
                  <Field
                    name="Start"
                    type="number"
                    :disabled="detail.range == 0"
                    :style="detail.range == 0 ? 'cursor:no-drop;' : ''"
                    v-model="detail.start_range"
                    class="form-control input-width"
                    placeholder="Start"
                  />
                </div>
                <div class="col-lg-6 col-md-5 col-sm-5" style="margin-top: 17px">
                  <label class="col-form-label" style="display: flex"></label>
                  <Field
                    name="End"
                    type="number"
                    :disabled="detail.range == 0"
                    v-model="detail.end_range"
                    :style="detail.range == 0 ? 'cursor:no-drop;' : ''"
                    class="form-control input-width mt-3"
                    placeholder="End"
                  />
                </div>
              </div>
              <div class="col-lg-1 col-sm-6 handle-radio">
                <div class="custom-control custom-radio mb-1">
                  <Field
                    v-model="detail.type"
                    type="radio"
                    value="PRICE"
                    id="is_broker_gross1"
                    name="is_broker_gross1"
                    class="custom-control-input ng-pristine ng-untouched ng-valid"
                    checked="checked"
                    style="height: unset !important"
                  />
                  <label
                    style="font-size: 13px; padding-top: 5px"
                    for="is_broker_gross1"
                    class="custom-control-label mt-1 order-radio-lable"
                    >Price</label
                  >
                </div>
                <div class="custom-control custom-radio">
                  <Field
                    v-model="detail.type"
                    type="radio"
                    value="PERCENT"
                    id="is_broker_gross2"
                    name="is_broker_gross2"
                    class="custom-control-input ng-pristine ng-untouched ng-valid"
                    checked="checked"
                    style="height: unset !important"
                  />
                  <label
                    style="font-size: 13px; padding-top: 5px"
                    for="is_broker_gross2"
                    class="custom-control-label mt-1 order-radio-lable"
                    >Percent</label
                  >
                </div>
                <span class="text-error"></span>
              </div>

              <div class="col-lg-1 col-sm-2 selct-width">
                <label
                  class="col-form-label"
                  style="display: flex; justify-content: flex-start"
                >
                  Value
                  <span class="text-danger">*</span> </label
                ><Field
                  name="value"
                  type="number"
                  v-model="detail.value"
                  placeholder="Value"
                  class="form-control input-width"
                />
              </div>

              <div
                class="col-lg-1 col-sm-1 "
                style="margin-top: 32px !important"
              >
                <button
                  class="save-btn"
                  style="width: 85px !important; margin-top: 0 !important"
                  id="save-button"
                  type="button"
                  v-on:click="save()"
                >
                  ADD
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div
        class="row"
        style="padding-left: 50px; padding-right: 50px; margin-top: 5px"
      >
        <div class="col-md-12 bg-light border-page">
          <div class="col-12 row">
            <div class="col-lg-6">
              <Field
                type="text"
                class="col-lg-3 form-control"
                name="ledger_balance"
                placeholder="SEARCH"
                v-model="keyword"
                v-on:keyup="getList()"
              />
            </div>
            <div class="col-lg-6 text-right">
              <button
                v-on:click="deleteSelecOne()"
                class="delete-btn mr-2 cursor-pointer"
                style="
                  width: 85px !important;
                  margin-top: 0 !important;
                  font-size: 14px;
                "
                id="delete-button"
                type="button"
              >
                DELETE
              </button>
            </div>
          </div>
          <table
            id="table"
            style="margin-top: 16px"
            data-toggle="table"
            data-search="true"
            data-filter-control="true"
            data-toolbar="#toolbar"
            class="table table-sm text-center text-white table-bordered product-list table-hover"
          >
            <thead>
              <tr>
                <th class="head">
                  <div class="switchToggleRead" style="text-align: start">
                    <input
                      type="checkbox"
                      v-model="isChecked"
                      :true-value="true"
                      :false-value="false"
                      v-on:change="checkall(isChecked)"
                    />
                    Is Delete
                  </div>
                </th>
                <th
                  class="head sorting"
                  id="id-Client"
                  v-on:click="sorting('users.name', 'id-Client')"
                >
                  Client Name
                </th>
                <th
                  class="head sorting"
                  id="id-scripts"
                  v-on:click="sorting('instrument_token', 'id-scripts')"
                >
                  Symbol
                </th>
                <th
                  class="head sorting"
                  id="id-start_range"
                  v-on:click="sorting('start_range', 'id-start_range')"
                >
                  Rate Start
                </th>
                <th
                  class="head sorting"
                  id="id-end_range"
                  v-on:click="sorting('end_range', 'id-end_range')"
                >
                  Rate End
                </th>
                <th
                  class="head sorting"
                  id="id-type"
                  v-on:click="sorting('type', 'id-type')"
                >
                  Price/Percent
                </th>
                <th
                  class="head sorting"
                  id="id-values"
                  v-on:click="sorting('value', 'id-value')"
                >
                  Value
                </th>
                <th
                  class="head sorting"
                  id="id-created_at"
                  v-on:click="sorting('created_at', 'id-created_at')"
                >
                  Add Time
                </th>
                <!-- <th class="head">Delete</th> -->
              </tr>
            </thead>
            <tbody v-show="!loader">
              <tr v-for="(data, index) in list" :key="index">
                <td class="body" style="text-align: start">
                  <div class="switchToggleRead">
                    <input
                      :id="'index_' + data.id"
                      type="checkbox"
                      v-model="data.isChecked"
                      v-on:change="checkHandlling(data.isChecked)"
                      :true-value="true"
                      :false-value="false"
                    />
                  </div>
                </td>
                <td class="body">{{ data.user ? data.user.name : "" }}</td>
                <td class="body">
                  {{ data.instrument_token }}
                </td>
                <td class="body">
                  {{ data.start_range ? data.start_range : "-" }}
                </td>
                <td class="body">
                  {{ data.end_range ? data.end_range : "-" }}
                </td>
                <td class="body">{{ data.type }}</td>
                <td class="body">{{ data.value }}</td>
                <td class="body">
                  {{ $helperService.getDateTime(data.created_at) }}
                </td>

                <!-- <td class="body">
                  <a
                    v-on:click="showDeletePopup(data, index)"
                    class="fa fa-trash text-danger"
                    style="cursor: pointer"
                    title="Delete"
                  ></a>
                </td> -->
              </tr>
            </tbody>
          </table>
          <ErrorComponent @retry="getList(0)" ref="errorComponent" />
          <div class="row mx-0 mb-4">
            <div class="col-lg-12 mt-5 text-center">
              <div class="page-bottom-pagination text-right">
                <Pagination
                  @page-change="pageChange"
                  @items-per-page-change="itemsPerPageChange"
                  ref="listPagination"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Field } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import Multiselect from "@vueform/multiselect";
export default {
  components: {
    ErrorComponent,
    Multiselect,
    Field,
    Pagination,
  },
  name: "ClientOrderLimit",
  data() {
    return {
      loader: true,
      isChecked: false,
      keyword: "",
      type: "Default",
      list: [],
      detail: {
        type: "PRICE",
        exchange: "COMEX",
        start_range: "",
        end_range: "",
        value: "",
        range: 0,
        instrument_token: "",
      },
      client_list: [],
      script_list: [],
      exchanges: [
      {
          name: "COMEX",
          value: "COMEX",
        },
      ],
      fromDate: "",
      toDate: "",
    };
  },
  mounted() {
    this.checkAccess();
    this.getClientList(0);
    this.getScriptList();
  },
  methods: {
    checkAccess() {
      var access = this.$store.getters.getAccess;
      if (access.is_orderLimit == 0) {
        this.$router.push("/access-denied");
      }
    },
    emptyValue() {
      this.detail.start_range = "";
      this.detail.end_range = "";
      this.detail.instrument_token = "";
    },
    getScriptList() {
      this.script_list = [];
      this.detail.instrument_token = "";
      var searchObj = {};
      searchObj.exchange = 'COMEX'
      this.$api
        .getAPI({
          _action: "/script-list-by-exchange",
          _body: searchObj,
        })
        .then((res) => {
          this.script_list.push({ instrument_token: "ALL", name: "ALL" });
          for (var i in res) {
            this.script_list.push(res[i]);
          }
          this.getList();
        })
        .catch(() => {});
    },
    getClientList() {
      this.$api
        .getAPI({
          _action: "/client-list",
        })
        .then((res) => {
          this.client_list = res;
          for (var i in this.client_list) {
            this.client_list[i].new_name =
              this.client_list[i].name + " (" + this.client_list[i].code + ")";
          }
        })
        .catch(() => {});
    },
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    checkall(isChecked) {
      for (var k in this.list) {
        if (isChecked) {
          this.list[k].isChecked = true;
        } else if (!isChecked) {
          this.list[k].isChecked = false;
        }
      }
    },
    checkHandlling(isChecked) {
      if (!isChecked) {
        this.isChecked = false;
      } else if (isChecked) {
        var count = -1;
        for (var k in this.list) {
          if (this.list[k].isChecked == false) {
            count = count + 1;
          }
        }
        console.log("object", count);
        if (count == 0) {
          this.isChecked = true;
        }
      }
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(obj.order_by, obj.sort_by);
    },
    getList(orderBy, sortBy) {
      this.$refs.errorComponent.updateFormLoader(true);
      this.list = [];
      var searchObj = {};

      if (this.detail.user_id) {
        searchObj.user_id = this.detail.user_id;
      }

      searchObj.exchange = 'COMEX'
      if (this.keyword) {
        searchObj.keyword = this.keyword;
      }
      if (orderBy) {
        searchObj.order_by = orderBy;
      }
      if (sortBy) {
        searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/client-order-setting-list",
          _body: searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res;
          res.list = this.list;
          for (var i in this.list) {
            this.list[i].isChecked = false;
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Data available");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    deleteSelecOne() {
      this.$refs.errorComponent.updateFormLoader(true);
      var array = [];
      for (var i in this.list) {
        if (this.list[i].isChecked) {
          array.push(this.list[i].id);
        }
      }
      var obj = {};
      obj.ids = array;

      if (array.length > 0) {
        this.$api
          .postAPI({
            _action: "/delete-order-setting",
            _body: obj,
          })
          .then((res) => {
            if (res) {
              this.$notify({
                title: "Success",
                type: "success",
                text: res.message,
              });
              this.$refs.errorComponent.updateFormLoader(false);
              this.getList();
            }
          })
          .catch(() => {
            this.$refs.errorComponent.updateFormLoader(false);
          });
      } else {
        this.$notify({
          type: "error",
          text: "Select atleast on setting.",
        });
        this.$refs.errorComponent.updateFormLoader(false);
      }
    },
    save() {
      this.$api
        .postAPI({
          _action: "/client-order-setting",
          _body: this.detail,
          _buttonId: "save-button",
        })
        .then((res) => {
          if (res) {
            this.$notify({
              title: "Success",
              type: "success",
              text: res.message,
            });
          }
          var user_id = this.detail.user_id;
          var exchange = this.detail.exchange;
          this.detail = {
            type : 'PRICE',
          };
          this.detail.user_id = user_id;
          this.detail.exchange = exchange;
          this.detail.range = 0;
          this.getList(0);
        })
        .catch(() => {});
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: white !important;
  max-height: 30px !important;
  min-height: 0px !important;
}

.multiselect-tag {
  background: #9cc338 !important;
}

.option-icon {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
}
</style>
